<template>
  <div>
    <page-header :on-add="showAdd" :page="page" />

    <filter-manager
      ref="filter"
      v-model="filterModel"
      :filters="filters"
      :open-advanced="isOpenAdvanced"
      @search="search"
    />

    <separator class="my-3" text="Lugares de Servicio" />

    <custom-callout v-for="(item, i) in serviceLocations" :key="i" class="pb-2">
      <div class="row">
        <div class="col-sm-2">
          <span class="font-14 color-gray-6">Tipo de Lugar:</span>
          <p class="font-16 color-black">{{ item.locationTypeName }}</p>
        </div>
        <div class="col-sm-2">
          <span class="font-14 color-gray-6">Municipio:</span>
          <p class="font-16 color-black">{{ item.municipalityName }}</p>
        </div>
        <div class="col-sm-4">
          <span class="font-14 color-gray-6">Nombre Lugar de Servicio:</span>
          <p class="font-16 color-black">{{ item.locationName }}</p>
        </div>
        <div
          :class="{
            'col-sm-2':
              item.isCertified === null &&
              isMedicaidDocumentationWorkflowEnabled,
            'col-sm-1':
              item.isCertified !== null &&
              isMedicaidDocumentationWorkflowEnabled,
          }"
        >
          <span class="font-14 color-gray-6">Teléfono:</span>
          <p class="font-16 color-black">
            {{ item.locationTelephoneNo | phone }}
          </p>
        </div>
        <div
          v-if="
            item.isCertified !== null && isMedicaidDocumentationWorkflowEnabled
          "
          class="col-sm-1 d-flex align-items-center"
        >
          <badge text="Certificada" :value="item.isCertified" />
        </div>
        <div class="col-sm-2 d-flex align-items-center">
          <action-button
            class="w-60"
            i="fas fa-file-import"
            text="Entrar"
            variant="outline-success"
            @click="onDetailClick(item)"
          />
        </div>
      </div>
    </custom-callout>
    <custom-result-not-found
      v-if="serviceLocations.length == 0"
      text="No hay información disponible"
    />

    <pagination
      v-if="serviceLocations.length > 0"
      :data="paginationData"
      @pagination-go-page="pageChanged"
    />

    <!-- <fixed-bottom-save-button /> -->
  </div>
</template>

<script>
import { PageHeader } from '@/shared/components/PageHeader/index';
import CustomCallout from '@/components/common/CustomCallout';
import ActionButton from '@/components/common/ActionButton';
import FilterManager from 'FilterManager';
import Badge from '@/components/common/Badge';
import {
  getServiceLocationTypes,
  getYears,
  searchServiceLocations,
  getCurrentAcademicYear,
  getServiceLocationServiceTypes,
  getCompanyMunicipalities,
} from '@/modules/provider/api.js';
import { getMunicipalities } from '@/modules/common/location.api';
import Pagination from '@/components/common/Pagination';
import mixWait from '@/mixins/vue-loading.js';
import mixAlert from '@/mixins/alert.mixin.js';
import storeMixin from '@/shared/mixins/storeGenerator';
import { getProvidersByAcademicyearId } from '@/modules/shared/provider.api';
import CustomResultNotFound from 'custom-result-not-found';
import { createNamespacedHelpers } from 'vuex';
import { name } from '@/modules/provider/store';
import types from '@/modules/provider/store/types';
import { getList as _getServiceLocations } from '@/modules/shared/servicelocation.api';
import { getSysparameterByNames as _getSysparameterByNames } from '@/modules/shared/sysparameter.api';
const { mapMutations, mapState } = createNamespacedHelpers(name);

export default {
  name: 'ProviderServiceLocation',
  components: {
    PageHeader,
    CustomCallout,
    ActionButton,
    FilterManager,
    Pagination,
    CustomResultNotFound,
    Badge,
  },
  mixins: [mixAlert, mixWait, storeMixin],
  data: () => ({
    page: {
      title: 'Lugares de Servicio',
      icon: 'fas fa-user-tie',
      routes: ['Proveedor / Lugares de Servicio', 'Lugares de Servicio'],
    },
    pagination: {
      currentPage: 1,
      totalItemCount: 0,
      pageCount: 1,
      count: 10,
    },
    isMedicaidDocumentationWorkflowEnabled: false,
    isOpenAdvanced: false,
    currentYear: null,
    years: [],
    providers: [],
    serviceTypes: [],
    locationTypes: [],
    municipalities: [],
    serviceLocations: [],
    servicePlaces: [],
    companyId: null,
    filterModel: {},
  }),
  computed: {
    ...mapState(name),
    showAdd() {
      return this.userHasPermissions('providers.servicelocation.add')
        ? this.add
        : null;
    },
    paginationData() {
      return {
        count: this.pagination.count,
        pageCount: this.pagination.pageCount,
        currentPage: this.pagination.currentPage,
        totalItemCount: this.pagination.totalItemCount,
      };
    },
    status() {
      return [
        { id: -1, name: 'Todos' },
        { id: 0, name: 'Inactivo' },
        { id: 1, name: 'Activo' },
      ];
    },
    filters() {
      return [
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          options: this.years,
          initialValue: this.currentYear,
          placeholder: 'Seleccione el año',
          fieldName: 'name',
          fieldKey: 'id',
          validations: 'required',
          clearable: false,
          class: 'col-md-3',
          onChanged: this.onYearChange,
        },
        {
          name: 'provider',
          component: 'CustomDropDown',
          options: this.providers,
          initialValue: this.providers.length == 1 ? this.providers[0] : null,
          placeholder: 'Seleccione Proveedor',
          fieldName: 'name',
          fieldKey: 'id',
          validations: 'required',
          clearable: true,
          error: 'El campo Proveedor es obligatorio',
          onChanged: this.onProviderChange,
          disabled: this.providers.length == 1,
        },
        {
          name: 'type',
          component: 'CustomDropDown',
          options: this.locationTypes,
          value: null,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-3',
          label: 'Tipo de Lugar:',
          isAdvanced: true,
        },
        {
          name: 'servicePlace',
          component: 'CustomDropDown',
          options: this.servicePlaces,
          value: null,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-3',
          validations: 'required',
          visible: this.isServicePlacesVisible,
          label: 'Lugar de Servicio:',
          isAdvanced: true,
          disabled: this.servicePlaces.length == 1,
        },
        {
          name: 'municipality',
          component: 'CustomDropDown',
          options: this.municipalities,
          value: null,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-3',
          label: 'Municipio:',
          isAdvanced: true,
        },
        {
          name: 'serviceType',
          component: 'CustomDropDown',
          options: this.serviceTypes,
          value: null,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-3',
          label: 'Tipo de Servicio:',
          isAdvanced: true,
        },
        {
          name: 'status',
          component: 'CustomDropDown',
          options: this.status,
          initialValue: this.status[2],
          placeholder: 'Seleccione',
          label: 'Estatus:',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
          class: 'col-md-3',
        },
      ];
    },
    isServicePlacesVisible() {
      return this.userHasPermissions('level.location');
    },
  },
  async mounted() {
    await this.getParams();
    this.ShowWait();
    await getYears().then((resp) => {
      this.years = resp;
      getCurrentAcademicYear().then((res) => {
        this.currentYear = { id: res.id, name: res.description };
        this.filterModel.academicYear = this.currentYear;
        this.onYearChange(this.currentYear);
      });
    });

    getServiceLocationTypes().then((resp) => {
      this.locationTypes = resp.data;
    });
    getServiceLocationServiceTypes().then((resp) => {
      this.serviceTypes = resp.data;
    });
    this.HideWait();
    this.setFilters(this.$store.state[name]?.serviceLocationFilters);
  },
  methods: {
    ...mapMutations(name, [types.SET_SERVICE_LOCATION_FILTERS]),
    async getParams() {
      const { data } = await _getSysparameterByNames({
        parameterNames: ['MedicaidDocumentationWorkflowEnabled'],
      });

      this.isMedicaidDocumentationWorkflowEnabled =
        data?.length > 0 && data[0].staticValue?.toLowerCase() == 'true';
    },
    pageChanged(page) {
      let filter = this.filterModel;
      filter.page = page;
      this.search(filter);
    },
    search(filter) {
      if (filter == null) {
        return;
      }
      searchServiceLocations({
        fiscalYearId: filter.academicYear.id,
        providerId: filter.provider.id,
        type: (filter.type || {}).id,
        locationId: this.isServicePlacesVisible
          ? filter.servicePlace?.id
          : null,
        municipalityId: (filter.municipality || {}).id,
        serviceTypeCode: (filter.serviceType || {}).id,
        activeStatus: filter.status
          ? filter.status.id >= 0
            ? !!(filter.status || {}).id
            : null
          : null,
        page: filter.page,
      }).then((res) => {
        this.serviceLocations = res.data;
        this.pagination.count = res.count;
        this.pagination.pageCount = res.pageCount;
        this.pagination.currentPage = res.currentPage;
        this.pagination.totalItemCount = res.totalItemCount;
        this.$store.commit(
          `${name}/${types.SET_SERVICE_LOCATION_FILTERS}`,
          filter
        );
      });
    },
    onYearChange(event) {
      let self = this;
      let companyId = null;
      self.currentYear =
        self.years.length > 1
          ? self.years.find((x) => x.id == event.id)
          : self.currentYear;
      let fiscalYearId = event.id;
      getProvidersByAcademicyearId(fiscalYearId).then((res) => {
        self.providers = res.data;
        if (self.providers.length == 1) {
          this.companyId = companyId = res[0]?.id ?? -1;
          self.filterModel.provider = this.providers[0];
          this.onProviderChange(this.providers[0]);
        }

        if (companyId != null) {
          getCompanyMunicipalities({
            fiscalYearId: event.id,
            companyId: companyId,
          }).then((res) => {
            self.municipalities = res;
          });
        } else {
          getMunicipalities({ AcademicYearId: event.id }).then((res) => {
            self.municipalities = res;
          });
        }
      });
    },
    onProviderChange(event) {
      if (event?.id) {
        this.callGetServiceTypes(event.id);
      } else {
        this.servicePlaces = [];
        this.filterModel.servicePlace = null;
      }
    },
    async callGetServiceTypes(companyId) {
      const { data } = await _getServiceLocations(companyId);
      this.servicePlaces = data;
      if (data.length == 1) {
        this.filterModel.servicePlace = data[0];
      }
    },
    add() {
      if (!this.filterModel.provider?.id) {
        this.ShowToast(
          'Error',
          ' Es requerido seleccionar Proveedor.',
          'error'
        );
        return;
      }
      this.$router.push({
        name: 'AddProviderServiceLocation',
        params: {
          fiscalYearId: this.currentYear.id,
          companyId: this.filterModel.provider?.id,
        },
      });
    },
    onDetailClick(item) {
      this.$router.push({
        name: 'EditProviderServiceLocation',
        params: {
          locationFiscalYearId: item.locationFiscalYearId,
        },
      });
    },
    setFilters(data) {
      if (data) {
        this.filterModel = data;
        this.isOpenAdvanced =
          data.municipality || data.serviceType || data.type;
        this.search(this.filterModel);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.has-hipaa > span,
.no-has-hipaa > span {
  font-size: 10px;
  margin-bottom: 2px;
}

.has-hipaa > span > i:last-child,
.no-has-hipaa > span > i:last-child {
  color: white;
}

.has-hipaa {
  background-color: #19bbef;
  color: white;
}
.has-hipaa > span > i:first-child {
  color: #73d7f9;
}
.no-has-hipaa {
  background-color: #c9545e;
  color: white;
}
.no-has-hipaa > span > i:first-child {
  color: #d4888c;
}
</style>
